<template>
    <div class="xl:w-2/5 lg:w-1/2 md:w-4/5 sm:w-2/3 mx-auto mt-8">
        <div v-if="!open">
            <div class="first:mt-0 mt-4" v-for="card in cards" :key="card.id">
                <label class="relative">
                    <input type="radio" name="payment" class="account-payment opacity-0 absolute left-0" />
                    <div
                        class="flex items-center justify-between cursor-pointer relative form-input w-full py-3 rounded leading-5 bg-teal-100 border border-teal-200 hover:border-teal-400 placeholder-gray-400 focus:outline-none focus:border-teal-500 focus:shadow-none sm:text-sm transition duration-150 ease-in-out mt-2"
                    >
                        <div class="account-payment-content flex items-center">
                            <img :src="card.brand | toBrandLogo" class="w-9 lg:mr-4 mr-3" :alt="card.brand" />
                            <span class="text-sm">terminación {{ card.last_four_digits }}</span>
                        </div>
                        <button
                            v-if="cards.length >= 2"
                            @click="deleteCard(card)"
                            class="text-sm text-blue-500 hover:text-blue-700 outline-none transition duration-300 ease-in-out"
                            :dusk="`remove-card-${card.id}`"
                        >
                            Eliminar
                        </button>
                    </div>
                </label>
            </div>

            <div class="first:mt-0 mt-4">
                <div
                    @click="open = true"
                    class="flex items-center justify-between cursor-pointer relative form-input w-full py-3 rounded leading-5 bg-teal-100 border border-teal-200 hover:border-teal-400 placeholder-gray-400 focus:outline-none focus:border-teal-500 focus:shadow-none sm:text-sm text-teal-500 transition duration-150 ease-in-out mt-2"
                >
                    <span class="text-sm">Agregar nueva tarjeta</span>
                    <svg class="h-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                        <path
                            fill="currentColor"
                            d="M376 232H216V72c0-4.42-3.58-8-8-8h-32c-4.42 0-8 3.58-8 8v160H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h160v160c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8V280h160c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z"
                        ></path>
                    </svg>
                </div>
            </div>
        </div>

        <div class="flex items-center mt-10">
            <img src="/images/stripe.png" class="h-7" alt="Logo de Stripe" />
        </div>

        <form class="form-loader" v-if="open" @submit.prevent="addCard" :class="{ active: isLoadingForm }">
            <div
                class="loader-container absolute bottom-0 left-0 right-0 top-0 w-full h-full flex flex-col items-center justify-center overflow-hidden z-2 bg-white opacity-85"
            >
                <div class="loader ease-linear rounded-full border-4 border-gray-300 h-12 w-12"></div>
                <h2 class="text-center text-xl font-semibold mt-6">Cargando...</h2>
                <p class="text-center">Se está procesando tu transacción</p>
            </div>
            <div>
                <label class="text-gray-500" for="card-name">Nombre del tarjetahabiente</label>
                <input
                    id="card-name"
                    type="text"
                    name="card-name"
                    v-model="form.name"
                    class="block w-full py-3 mt-2 leading-5 transition duration-150 ease-in-out rounded form-input bg-teal-100 border border-teal-200 placeholder-gray-400 focus:outline-none focus:border-teal-500 focus:shadow-none sm:text-sm"
                    placeholder="Escribe el nombre del tarjetahabiente"
                    autocomplete="cc-name"
                    required
                />
                <span v-if="errors.name" class="text-red-500 text-sm">{{ errors.name }}</span>
            </div>
            <div class="mt-4">
                <label class="text-gray-500" for="card-number-element">Número de tarjeta</label>
                <div class="flex items-center mt-2">
                    <div
                        id="card-number-element"
                        class="block w-full py-2 leading-5 placeholder-gray-500 transition duration-150 ease-in-out bg-gray-100 border border-gray-200 rounded form-input pr-11 focus:outline-none focus:placeholder-gray-500 focus:border-red-300 focus:shadow-none sm:text-sm"
                    ></div>
                    <img
                        :src="form.brand | toBrandLogo"
                        class="w-11 ml-4"
                        alt="Imagen de tarjeta de crédito ó débito"
                    />
                </div>
                <span v-if="errors.number" class="text-red-500 text-sm">{{ errors.number }}</span>
            </div>
            <div class="mt-4">
                <div class="grid grid-cols-11 xl:gap-4 sm:gap-3 gap-1">
                    <div class="col-span-6">
                        <label class="text-gray-500" for="card-expiry-element">Vigencia</label>
                        <div
                            id="card-expiry-element"
                            class="block w-full py-2 mt-2 leading-5 placeholder-gray-500 transition duration-150 ease-in-out bg-gray-100 border border-gray-200 rounded form-input focus:outline-none focus:placeholder-gray-500 focus:border-red-300 focus:shadow-none sm:text-sm"
                        ></div>
                        <span v-if="errors.expiry" class="text-red-500 text-sm">{{ errors.expiry }}</span>
                    </div>
                    <div class="col-span-5">
                        <label class="flex items-center justify-between text-gray-500" for="card-cvv">
                            CVV
                            <div class="flex items-center ml-8 tooltip first:ml-0 z-1">
                                <div
                                    class="border-2 border-gray-500 flex items-center justify-center rounded-full w-4 h-4"
                                >
                                    <svg
                                        class="w-2 h-2 text-gray-500"
                                        viewBox="0 0 50.67 109.48"
                                        xmlns="http://www.w3.org/2000/svg"
                                        role="img"
                                        aria-label="Icono para habilitar tooltip"
                                    >
                                        <path
                                            fill="currentColor"
                                            stroke="2"
                                            d="M47.77 96.49l-1.49 6.08q-6.7 2.64-10.69 4a28 28 0 01-9.26 1.38c-5.4 0-9.61-1.33-12.6-4a12.78 12.78 0 01-4.5-10 35 35 0 01.34-4.83c.22-1.65.59-3.5 1.08-5.58l5.58-19.74q.75-2.83 1.26-5.38a23.45 23.45 0 00.5-4.62c0-2.52-.52-4.29-1.56-5.28s-3-1.49-6-1.49a15.51 15.51 0 00-4.44.68c-1.52.45-2.81.88-3.9 1.28l1.53-6.04q5.52-2.24 10.52-3.83a31.37 31.37 0 019.48-1.59q8.06 0 12.42 3.89a12.92 12.92 0 014.36 10.1q0 1.29-.3 4.53a30.63 30.63 0 01-1.12 6l-5.59 19.62a54.34 54.34 0 00-1.25 5.42 28.55 28.55 0 00-.54 4.59q0 3.92 1.75 5.34c1.18 1 3.2 1.42 6.08 1.42a17.56 17.56 0 004.59-.71 26.22 26.22 0 003.75-1.24zm1.37-82.54a11.51 11.51 0 01-3.88 8.76 13.21 13.21 0 01-9.36 3.62 13.34 13.34 0 01-9.4-3.62 11.48 11.48 0 01-3.89-8.76 11.59 11.59 0 013.92-8.8 13.31 13.31 0 019.4-3.65 13.2 13.2 0 019.36 3.65 11.62 11.62 0 013.85 8.8z"
                                        />
                                    </svg>
                                </div>
                                <div
                                    class="tooltip-text lg:-ml-25 md:-ml-19 sm:-ml-22 -ml-40 lg:-mt-48 md:-mt-40 -mt-22"
                                >
                                    <div class="px-3 py-3 text-xs text-white bg-black rounded-md">
                                        <img
                                            src="/images/tooltip-card.png"
                                            class="lg:w-48 md:w-36 w-40"
                                            alt="Imagen informativa del CVV de la tarjeta"
                                        />
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            x="0px"
                                            y="0px"
                                            viewBox="0 0 255 255"
                                            class="absolute left-0 sm:w-full h-4 text-black mt-3 sm:ml-0 ml-40"
                                        >
                                            <polygon points="0,0 127.5,127.5 255,0" class="fill-current"></polygon>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </label>
                        <div
                            id="card-cvc-element"
                            class="block w-full py-2 mt-2 leading-5 placeholder-gray-500 transition duration-150 ease-in-out bg-gray-100 border border-gray-200 rounded form-input pr-11 focus:outline-none focus:placeholder-gray-500 focus:border-red-300 focus:shadow-none sm:text-sm"
                        ></div>
                        <span v-if="errors.cvc" class="text-red-500 text-sm">{{ errors.cvc }}</span>
                    </div>
                </div>
            </div>
            <div class="relative flex items-start mt-8">
                <div class="flex items-center h-5">
                    <input
                        id="accept-legals-register-card"
                        v-model="form.terms"
                        name="accept-legals-register-card"
                        type="checkbox"
                        class="w-4 h-4 text-red-500 transition duration-150 ease-in-out form-checkbox focus:shadow-none"
                        required
                    />
                </div>
                <div class="ml-3 text-sm leading-5">
                    <label for="accept-legals-register-card" class="text-gray-500"
                        >Al agregar aceptas
                        <a
                            :href="terms"
                            class="text-teal-500 transition duration-300 ease-in-out outline-none hover:text-teal-700"
                            target="_blank"
                            rel="noopener noreferrer nofollow"
                            >Términos y condiciones</a
                        >
                        y
                        <a
                            :href="privacy"
                            class="text-teal-500 transition duration-300 ease-in-out outline-none hover:text-teal-700"
                            target="_blank"
                            rel="noopener noreferrer nofollow"
                            >Aviso de privacidad</a
                        >
                        de Círculo Plus.</label
                    >
                </div>
            </div>
            <div class="flex items-center justify-between sm:flex-row flex-col mt-8">
                <button
                    @click="open = false"
                    class="btn btn-outline-red inline-block px-2 sm:w-1/2 w-full py-2 first:ml-0 sm:ml-2 first:mt-0 sm:mt-0 mt-3"
                >
                    Cancelar
                </button>
                <button
                    type="submit"
                    :disabled="isLoadingButtonAdd"
                    class="btn btn-red inline-block px-2 sm:w-1/2 w-full py-2 first:ml-0 sm:ml-2 first:mt-0 sm:mt-0 mt-3"
                    :class="{ disabled: isLoadingButtonAdd }"
                >
                    Agregar
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import { loadStripe } from '@stripe/stripe-js';
import { toBrandLogo } from '../filters';
import sweetAlert from 'sweetalert2';
import PasswordToggle from './PasswordToggle';

export default {
    name: 'Cards',

    props: {
        cards: Array,
        terms: String,
        privacy: String,
    },

    components: {
        PasswordToggle,
    },

    filters: {
        toBrandLogo,
    },

    watch: {
        open: function (newOpen) {
            if (newOpen) {
                this.setupStripe();
            }
        },
    },

    data() {
        return {
            stripe: null,
            cardNumberElement: null,
            cardExpiryElement: null,
            cardCvcElement: null,
            open: false,
            isLoadingButtonAdd: false,
            isLoadingForm: false,
            form: {
                name: '',
                brand: '',
                token_id: '',
                terms: false,
            },
            errors: {
                name: '',
                number: '',
                expiry: '',
                cvc: '',
                terms: '',
            },
            options: {
                classes: {
                    focus: 'border-red-300',
                },
                style: {
                    base: {
                        fontSize: '14px',
                        fontFamily: 'Mulish, inherit',
                    },
                },
            },
        };
    },

    methods: {
        async setupStripe() {
            this.stripe = await loadStripe($('meta[name="stripe-key"]').attr('content'), {
                locale: 'es',
            });
            this.createAndMountElements();
        },

        createAndMountElements() {
            const elements = this.stripe.elements();
            this.cardNumberElement = elements.create('cardNumber', this.options);
            this.cardNumberElement.mount('#card-number-element');
            this.cardExpiryElement = elements.create('cardExpiry', this.options);
            this.cardExpiryElement.mount('#card-expiry-element');
            this.cardCvcElement = elements.create('cardCvc', this.options);
            this.cardCvcElement.mount('#card-cvc-element');
            this.cardNumberElement.on('change', (event) => {
                this.form.brand = event.brand;
                this.errors.number = event.error ? event.error.message : '';
            });
            this.cardExpiryElement.on(
                'change',
                (event) => (this.errors.expiry = event.error ? event.error.message : '')
            );
            this.cardCvcElement.on('change', (event) => (this.errors.cvc = event.error ? event.error.message : ''));
        },

        addCard() {
            this.isLoadingButtonAdd = true;
            this.isLoadingForm = true;

            if (this.checkForm()) {
                this.stripe
                    .createToken(this.cardNumberElement, {
                        name: this.form.name,
                        currency: 'MXN',
                    })
                    .then((result) => {
                        if (result.error) {
                            this.isLoadingButtonAdd = false;
                            this.isLoadingForm = false;
                            sweetAlert.fire('Error', result.error.message, 'error');
                        } else {
                            this.form.token_id = result.token.id;

                            axios
                                .post('/cards', this.form)
                                .then(() => {
                                    this.isLoadingButtonAdd = false;
                                    this.isLoadingForm = false;
                                    this.open = false;

                                    window.location.reload();
                                })
                                .catch((error) => {
                                    this.isLoadingButtonAdd = false;
                                    this.isLoadingForm = false;

                                    let errors = error.response.data.errors;

                                    console.log(errors);

                                    sweetAlert.fire('Error', 'Verifica tus datos.', 'error');
                                });
                        }
                    });
            }
        },

        checkForm() {
            if (this.form.name && this.form.terms) {
                return true;
            }
            if (!this.form.name) {
                this.errors.name = 'El campo nombre del tarjetahabiente es requerido.';
                this.loading = false;
                this.isLoadingForm = false;
            }
            if (!this.form.terms) {
                this.errors.terms = 'El campo términos y condiciones es requerido.';
                this.loading = false;
                this.isLoadingForm = false;
            }
            return false;
        },

        deleteCard(card) {
            axios.delete('/cards/' + card.id).then(() => {
                window.location.reload();
            });
        },
    },
};
</script>
